export default __webpack_public_path__ + "static/media/bk1.3ad5d047.jpg";